import { createStore } from 'vuex'
import axios from 'axios'

export default createStore({
  state: {
    challenge: null,
    loading: false,
  },
  getters: {
  },
  mutations: {
    setChallenge(state, challenge) {
      state.challenge = challenge;
    },
    setLoading(state, l) {
      state.loading = l;
    },
  },
  actions: {
    async fetchChallenge({ commit }) {
      commit('setLoading', true)

      const response = await axios.get("https://sportips.fr/challenge-granfondo-2026/api/endpoints/challenge/get.php");
      if (response.status === 200) {
        commit('setChallenge', response.data);
      }
      commit('setLoading', false);
    }
  },
  modules: {
  }
})
